import { Loader, If, Button, FgtsSlider } from '@itau-loans-www/components'

import './authorize-fgts-section.scss'
import { useAuthorizeFgts } from './hooks'
import sliderData from './sliderData'

const AuthorizeFgtsSection = ({ allowButton = true }) => {
  const { loading, alreadyAuthorized, knowMore, carouselConfig } =
    useAuthorizeFgts()

  return (
    <div className="authorize-fgts">
      <Loader visible={loading} hasOverlay />
      <FgtsSlider slides={sliderData} config={carouselConfig} />
      <div className="authorize-fgts__buttons">
        <Button
          id="info-btn"
          data-testid="info-btn"
          variant="secondary"
          onClick={knowMore}
        >
          acessar o app
        </Button>
        <If
          condition={allowButton}
          renderIf={
            <Button
              id="authorize-btn"
              data-testid="authorize-btn"
              onClick={alreadyAuthorized}
            >
              Já autorizei
            </Button>
          }
        />
      </div>
    </div>
  )
}

export default AuthorizeFgtsSection
